/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Financialreturns_Latest2Inputs */

const en_coinvestments_report_financialreturns_latest2 = /** @type {(inputs: Coinvestments_Report_Financialreturns_Latest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financial Returns · Latest`)
};

/**
* | output |
* | --- |
* | "Financial Returns · Latest" |
*
* @param {Coinvestments_Report_Financialreturns_Latest2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_financialreturns_latest2 = /** @type {((inputs?: Coinvestments_Report_Financialreturns_Latest2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Financialreturns_Latest2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_financialreturns_latest2(inputs)
});
export { coinvestments_report_financialreturns_latest2 as "coInvestments_report_financialReturns_latest" }